import { z } from "zod";

export const inviteTabValueSchema = z.enum([
  "connections",
  "invitations",
  "recommended",
]);
export type InviteTabValue = z.infer<typeof inviteTabValueSchema>;
